import { Box, Copy, H5, Icon, IconWrapper } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSelectedFilterEmpty, setSelectedFilterItemsAction } from '../../../core/reducers/vehicleListFilters';
import themeStyles from '../VehicleListFilters.styles';
const FiltersWrapper = themeStyles.apply(Box, 'FiltersWrapper');
const HeaderWrapper = themeStyles.apply(Box, 'HeaderWrapper');
const DesktopResetFiltersButton = themeStyles.apply(Copy, 'DesktopResetFiltersButton');
const ResetIcon = themeStyles.apply(Icon, 'ResetIcon');
const FiltersListDesktop = ({ filterOptionsList }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isSelectedFilterEmpty = useSelector(selectIsSelectedFilterEmpty);
    const handlerResetAll = () => {
        dispatch(setSelectedFilterItemsAction([]));
    };
    return (React.createElement(FiltersWrapper, { "data-testid": "cy-vehicle-list-filters" },
        React.createElement(HeaderWrapper, null,
            React.createElement(H5, { "data-testid": "cy-filters-header" }, t('Pages.Models.Exploration.filterHeading')),
            React.createElement(DesktopResetFiltersButton, { size: "small", onClick: handlerResetAll, as: "button", disabled: isSelectedFilterEmpty, "data-testid": "cy-filters-resetAll-button" },
                React.createElement(IconWrapper, null,
                    React.createElement(ResetIcon, { name: "reset" })),
                t('Pages.Models.Exploration.filterResetLabel'))),
        filterOptionsList));
};
export default FiltersListDesktop;
